export const environment = {
  production: false,
  // NA_xerxesUrl: 'https://enterprise.xerxes.comcast.net/',
  NA_xerxesUrl:   'https://ent.preprod.passportsecure.net/',
  //EU_xerxesUrl: 'https://xerxes-ent-eu-prod.xerxes.comcast.com/',
  EU_xerxesUrl:   'https://eu-ent.preprod.passportsecure.net/',
  APAC_xerxesUrl: 'https://ap-ent.preprod.passportsecure.net/',
  NA_xerxesApp: 'pmp',
  // NA_xerxesApp: 'si-staging',
  //EU_xerxesApp: 'si-eu-staging',
  EU_xerxesApp: 'pmp',
  APAC_xerxesApp: 'si-staging-ap-region',
  partners: [
    'Comcast',
    'Sky-Group',
    'Cox',
    'Rogers',
    'Shaw',
    'Videotron',
    'Foxtel',
    'Charter',
  ],
  feedPartnersList: [
    'cox',
    'sky-group',
    'rogers',
    'videotron',
    'shaw',
    'foxtel',
    'charter',
  ],
  releaseNotesId: '1362897269',
  defaultAwsAccount: '721300565931',
};
